<template>
  <v-dialog
    v-model="dialog"
    persistent
    width="30%">
    <v-card>
      <v-card-title
        class="headline grey lighten-2"
        primary-title>
        {{ title }}
      </v-card-title>
      <v-card-text>
        <v-form
          ref="form"
          v-model="isValidationOk"
          lazy-validation>
          <v-container
            py-0>
            <v-layout
              wrap>
              <v-flex
                xs12
                md12
                lg12>
                <v-textarea
                  v-model="labelText"
                  background-color="amber lighten-4"
                  readonly
                  auto-grow
                  full-width
                  filled
                  shaped
                  solo
                  outlined/>
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-card-text>
      <v-divider/>
      <v-card-actions>
        <v-flex
          xs3
          md3/>
        <v-flex
          xs2
          md2
          text-xs-right>
          <v-btn
            :disabled="!isValidationOk"
            color="secondary"
            flat
            @click="closeDialog(true)">
            {{ $t('Yes') }}
          </v-btn>
        </v-flex>
        <v-flex
          xs1
          md1/>
        <v-flex
          xs2
          md2
          text-xs-center>
          <v-btn
            color="primary"
            flat
            @click="closeDialog(false)">
            {{ $t('No') }}
          </v-btn>
        </v-flex>
        <v-flex
          xs3
          md3/>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

export default {
  props: {
    componentKey: {
      type: String,
      required: true
    },
    dialog: {
      type: Boolean,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    labelText: {
      type: String,
      required: true
    },
    customPar1: {
      type: String,
      required: false,
      default: ''
    },
    customPar2: {
      type: String,
      required: false,
      default: ''
    },
    customPar3: {
      type: Object,
      required: false,
      default: undefined
    }
  },
  data: () => ({
    isValidationOk: true
  }),
  mounted () {
  },
  methods: {
    closeDialog (result) {
      this.$emit('dialogResultYesNo', this.componentKey, result, this.customPar1, this.customPar2, this.customPar3)
    }
  }
}
</script>
